import { Component, OnInit, Input, ChangeDetectorRef, OnChanges, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '@ukam/shell/services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from '@ukam/shell/layouts/full/horizontal/sidebar/nav-item/nav-item.component';
import { CommonModule } from '@angular/common';
import { NAV_ITEMS } from '@ukam/shell/nav/nav-items.token';

@Component({
  selector: 'app-horizontal-sidebar',
  imports: [AppHorizontalNavItemComponent, CommonModule],
  templateUrl: './sidebar.component.html',
})
export class AppHorizontalSidebarComponent implements OnInit {
  navService = inject(NavService);
  router = inject(Router);

  navItems = inject(NAV_ITEMS);
  parentActive = '';

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor() {
    const media = inject(MediaMatcher);
    const changeDetectorRef = inject(ChangeDetectorRef);

    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe(
      () => (this.parentActive = this.router.url.split('/')[1])
    );
  }

  ngOnInit(): void {
    this.parentActive = this.router.url.split('/')[1];

    this.router.events.subscribe(() => {
      this.parentActive = this.router.url.split('/')[1];
    });
  }
}
